import React, { useEffect, useState } from 'react';
import { indicatorApi } from '../services/api';

interface Indicator {
  id: number;
  name: string;
  last: string | null;
  current: string | null;
}

const IndicatorBar: React.FC = () => {
  const [indicators, setIndicators] = useState<Indicator[]>([]);

  useEffect(() => {
    const fetch = () => indicatorApi.list().then((res) => setIndicators(res.data)).catch(() => {});
    fetch();
    const interval = setInterval(fetch, 60_000);
    return () => clearInterval(interval);
  }, []);

  if (indicators.length === 0) return null;

  return (
    <div style={styles.bar}>
      {indicators.map((ind) => {
        const current = parseFloat(ind.current || '0');
        const last = parseFloat(ind.last || '0');
        const diff = current - last;
        const color = diff >= 0 ? 'green' : 'red';
        const decimals = ind.name === 'USD/CAD' ? 3 : 2;
        return (
          <span key={ind.id} style={styles.item}>
            <span style={styles.name}>{ind.name}</span>
            <span style={{ color, fontWeight: 'normal' }}>
              {current.toFixed(decimals)}
            </span>
            <span style={{ color, fontWeight: 'normal' }}>
              {diff >= 0 ? '+' : ''}{diff.toFixed(decimals)}
            </span>
          </span>
        );
      })}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  bar: {
    display: 'flex',
    gap: '16px',
    padding: '4px 12px',
    backgroundColor: '#fff',
    borderBottom: '1px solid #727272',
    color: '#1a1a1a',
    fontSize: '1em',
    fontWeight: 'bold',
    overflowX: 'auto',
  },
  item: { display: 'flex', gap: '8px', whiteSpace: 'nowrap' },
  name: { fontWeight: 'bold', color: '#1a1a1a' },
};

export default IndicatorBar;
